export default __webpack_public_path__ + "static/media/mg42.baf7fc73.svg";